import * as actions from './actions';
import * as getters from './getters';

import { SET_ORIGINAL_QUOTE, SET_ORIGINAL_DONATION } from './mutation-types';

// initial state
const initialState = {
    original_quote: {
        id: null,
        source_id: null,
        pickup_location: {
            data: {
                id: null,
                name: null,
            },
        },
        pickup_location_id: null,
        dropoff_location: {
            data: {
                id: null,
                name: null,
            },
        },
        dropoff_location_id: null,
        start_date: null,
        start_time: null,
        end_date: null,
        end_time: null,
        age: null,
        promo_code: null,
        loyalty_discount: null,
        birthday_loyalty_discount_applied: null,
        green_heart_donation: false,
        currency: null,
        converted_currency: null,
        locale: null,
        guest_token: null,
        payment_type: 'PP',
        pay_on_arrival_available: true,
        customer: null,
        selected_vehicle: {
            data: {
                id: null,
                total: 0,
                vehicle: {
                    data: {
                        acriss: null,
                        adults: 0,
                        air_conditioning: 0,
                        children: 0,
                        co2: 0,
                        currency: null,
                        discount: 0,
                        discount_percentage: null,
                        excess: 0,
                        fuel: null,
                        group: null,
                        id: null,
                        image: null,
                        loyalty_discount_applied: null,
                        luggage_large: 0,
                        luggage_medium: 0,
                        luggage_small: 0,
                        mpg: null,
                        name: null,
                        original_price: 0,
                        poa_deposit: 0,
                        total_poa: 0,
                        total_pp: 0,
                        transmission: null,
                        charge_totals: [],
                    },
                },
                selected_insurance_options: {
                    data: [],
                },
            },
        },
    },
};

// mutations
const mutations = {
    [SET_ORIGINAL_QUOTE](state, quote) {
        state.original_quote = quote;
    },

    [SET_ORIGINAL_DONATION](state, donation) {
        state.original_quote.green_heart_donation = donation;
    },
};

export default {
    state: { ...initialState },
    actions,
    getters,
    mutations,
};
